export const getRoles = store => store.roles
